import { Interface } from '@ethersproject/abi';
import RECIPIENT from './gsn-recipient.json';

const GSN_RECIPIENT_INTERFACE = new Interface(RECIPIENT);

export { GSN_RECIPIENT_INTERFACE };
